export enum EOpeningType
{
    /// <summary>
    /// Hinge
    /// </summary>
    H = 1,
    /// <summary>
    /// Lift
    /// </summary>
    L = 2,
    /// <summary>
    /// Vertical Lift
    /// </summary>
    VL = 3,
    /// <summary>
    /// Flap
    /// </summary>
    F = 4,
    /// <summary>
    /// Bar
    /// </summary>
    B = 5,
    /// <summary>
    /// Slide
    /// </summary>
    S = 6,
}